class ProductMediasSlider extends HTMLElement {
  constructor() {
    super()
    this.currentSlide = 0
    this.isSliderActive = false
    this.isDragging = false
    this.startX = 0
    this.startY = 0
    this.endX = 0
  }

  connectedCallback() {
    this.slider = this.querySelector('.product-medias')
    this.sliderContainer = this.querySelector('.product-medias__slider')
    this.slides = this.querySelectorAll('.product-medias__slide')
    this.thumbnails = this.querySelectorAll('.product-medias__thumbnail')
    
    // Créer les références des fonctions liées
    this.boundResizeHandler = this.checkScreenSize.bind(this)
    this.boundTouchStart = this.handleTouchStart.bind(this)
    this.boundTouchEnd = this.handleTouchEnd.bind(this)
    this.boundMouseDown = this.handleMouseDown.bind(this)
    this.boundMouseMove = this.handleMouseMove.bind(this)
    this.boundMouseUp = this.handleMouseUp.bind(this)
    this.boundTouchMove = this.handleTouchMove.bind(this)
    this.boundClickThumbnail = this.handleClickThumbnail.bind(this)
    
    if (this.slider && this.slides.length > 0) {
      this.init()
    }
  }

  disconnectedCallback() {
    // Nettoyage automatique des event listeners
    this.removeAllEventListeners()
  }

  init() {
    // console.log('init slider product');
    if (!this.slider || this.slides.length === 0) return
    
    this.checkScreenSize()
    this.setupEventListeners()
  }

  checkScreenSize() {
    const isMobile = window.innerWidth < 900
    this.isSliderActive = isMobile && this.slides.length > 1
    
    if (this.isSliderActive) {
      this.activateSlider()
    } else {
      this.deactivateSlider()
    }
  }

  setupEventListeners() {
    // Resize listener
    window.addEventListener('resize', this.boundResizeHandler)

    if (this.isSliderActive) {
      this.addTouchSupport()
    }
  }


  activateSlider() {
    this.sliderContainer.classList.add('mobile-slider')
    this.addTouchSupport()
  }

  deactivateSlider() {
    this.sliderContainer.classList.remove('mobile-slider')
    // Supprimer seulement les event listeners du slider
    this.removeSliderEventListeners()
  }

  removeSliderEventListeners() {
    if (this.sliderContainer) {
      this.sliderContainer.removeEventListener('touchstart', this.boundTouchStart)
      this.sliderContainer.removeEventListener('touchend', this.boundTouchEnd)
      this.sliderContainer.removeEventListener('mousedown', this.boundMouseDown)
      this.sliderContainer.removeEventListener('mousemove', this.boundMouseMove)
      this.sliderContainer.removeEventListener('mouseup', this.boundMouseUp)
      this.sliderContainer.removeEventListener('touchmove', this.boundTouchMove)
    }
    
    // Supprimer les event listeners des thumbnails
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.removeEventListener('click', this.boundClickThumbnail)
    })
  }

  removeAllEventListeners() {
    // Supprimer tous les event listeners du resize
    window.removeEventListener('resize', this.boundResizeHandler)
    
    // Supprimer tous les event listeners du slider
    this.removeSliderEventListeners()
  }

  addTouchSupport() {
    // Support tactile (mobile)
    this.sliderContainer.addEventListener('touchstart', this.boundTouchStart, { passive: true })
    this.sliderContainer.addEventListener('touchend', this.boundTouchEnd, { passive: true })
    this.sliderContainer.addEventListener('touchmove', this.boundTouchMove, { passive: false })

    // Support souris (desktop)
    this.sliderContainer.addEventListener('mousedown', this.boundMouseDown)
    this.sliderContainer.addEventListener('mousemove', this.boundMouseMove)
    this.sliderContainer.addEventListener('mouseup', this.boundMouseUp)
    
    // Event listeners pour les thumbnails
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', this.boundClickThumbnail)
    })
  }

  handleTouchStart(e) {
    this.startX = e.touches[0].clientX
    this.startY = e.touches[0].clientY
    this.isDragging = true
  }

  handleTouchEnd(e) {
    if (!this.isDragging) return
    this.endX = e.changedTouches[0].clientX
    this.handleSwipe(this.startX, this.endX)
    this.isDragging = false
  }

  handleTouchMove(e) {
    if (this.isDragging) {
      const currentX = e.touches[0].clientX
      const currentY = e.touches[0].clientY
      const deltaX = Math.abs(currentX - this.startX)
      const deltaY = Math.abs(currentY - this.startY)
      
      // Ne prévenir le comportement par défaut que si le mouvement horizontal est plus important que le vertical
      if (deltaX > deltaY) {
        e.preventDefault()
      }
    }
  }

  handleMouseDown(e) {
    e.preventDefault()
    this.isDragging = true
    this.startX = e.clientX
  }

  handleMouseMove(e) {
    if (!this.isDragging) return
    e.preventDefault()
  }

  handleMouseUp(e) {
    if (!this.isDragging) return
    e.preventDefault()
    this.isDragging = false
    this.endX = e.clientX
    this.handleSwipe(this.startX, this.endX)
  }

  handleSwipe(startX, endX) {
    const threshold = 40 // Seuil minimum pour déclencher le swipe
    const diff = startX - endX

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swipe vers la gauche - slide suivante
        this.nextSlide()
      } else {
        // Swipe vers la droite - slide précédente
        this.prevSlide()
      }
    }
  }

  nextSlide() {
    if (this.currentSlide < this.slides.length - 1) {
      this.currentSlide++
    } else {
      this.currentSlide = 0
    }
    this.goToSlide(this.currentSlide)
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--
      this.goToSlide(this.currentSlide)
    }
  }

  goToSlide(index) {
    if (index >= 0 && index < this.slides.length) {
      this.currentSlide = index
      const slideWidth = this.sliderContainer.offsetWidth
      const scrollLeft = index * slideWidth
      
      this.sliderContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      })
    }

    this.setActiveThumbnail(this.slides[index].getAttribute('data-slide'))
  }

  setActiveThumbnail(slideId) {
    const thumbnail = this.slider.querySelector(`[data-thumbnail="${slideId}"]`)
    if (thumbnail) {
      this.slider.querySelector('.product-medias__thumbnail.active').classList.remove('active')
      thumbnail.classList.add('active')
    }
  }

  handleClickThumbnail(e) {
    e.preventDefault()
    e.stopPropagation()

    const thumbnailId = e.target.closest('.product-medias__thumbnail').getAttribute('data-thumbnail')
    console.log("handleClickThumbnail ", thumbnailId)
    
    // Trouver l'index de la slide correspondante
    const slideIndex = Array.from(this.slides).findIndex(slide => {
      return slide.getAttribute('data-slide') === thumbnailId
    })
    
    if (slideIndex !== -1) {
      // Mettre à jour l'état actif du thumbnail
      this.slider.querySelector('.product-medias__thumbnail.active')?.classList.remove('active')
      e.target.closest('.product-medias__thumbnail').classList.add('active')
      
      // Aller à la slide correspondante
      this.goToSlide(slideIndex)
    }
  }

}

// Enregistrer le Web Component
customElements.define('product-medias-slider', ProductMediasSlider)
